export default __webpack_public_path__ + "static/media/lap_image8.1d217dcc.webp";